export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="rounded-2xl bg-gradient-to-br from-primary-500 via-primary-600 to-primary-700 overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center gap-8 p-8 md:p-12 lg:p-16">
            <div className="flex-1 text-center lg:text-left">
              <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-background-50/20 text-background-50 text-xs font-medium mb-4">
                <i className="ri-smartphone-line"></i>
                随时随地的阅读
              </span>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-3">
                手机阅读更尽兴
              </h2>
              <p className="text-background-50/80 text-sm md:text-base leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
                香香漫画完美适配手机端，专为移动阅读优化的下拉式体验，无需下载APP，浏览器打开即可畅读全部韩漫全集。躺在床上、坐地铁、等咖啡，随时随地追更最新韩漫。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <div className="flex items-center gap-2 px-5 py-3 rounded-full bg-background-50 text-primary-600 font-medium text-sm cursor-pointer hover:bg-background-100 transition-colors whitespace-nowrap">
                  <i className="ri-android-line text-lg"></i>
                  Android 版
                </div>
                <div className="flex items-center gap-2 px-5 py-3 rounded-full bg-background-50/15 text-background-50 border border-background-50/30 font-medium text-sm cursor-pointer hover:bg-background-50/25 transition-colors whitespace-nowrap">
                  <i className="ri-apple-line text-lg"></i>
                  iOS 版
                </div>
              </div>
            </div>
            <div className="flex-1 flex justify-center">
              <div className="relative">
                <div className="absolute inset-0 bg-background-50/10 rounded-3xl blur-3xl"></div>
                <img
                  src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20showing%20Korean%20webtoon%20manhwa%20reading%20interface%20on%20mobile%20screen%2C%20vertical%20scroll%20comic%20layout%2C%20clean%20modern%20UI%20design%2C%20warm%20color%20scheme%2C%20isolated%20on%20transparent%20background%2C%20professional%20app%20mockup&width=400&height=600&seq=app-mobile-mockup&orientation=portrait"
                  alt="香香漫画手机阅读界面"
                  className="relative w-48 md:w-56 lg:w-64 h-auto"
                  width="400"
                  height="600"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}